import { format } from 'owa-localize';
import InboxRuleRequestStatus from '../store/schema/InboxRuleRequestStatus';
import InboxRuleStore from '../store/schema/InboxRuleStore';
import inboxRuleStore from '../store/store';
import { trace } from 'owa-trace';
import { action, select } from 'satcheljs/lib/legacy';

export interface SetInboxRuleRequestStatusState {
    inboxRuleStore: InboxRuleStore;
}

/**
 * Validate the old and new create rule request states are expected
 * @param oldStatus current create rule request status in store
 * @param newStatus the create rule request status to be set
 */
function validateInboxRuleRequestState(
    oldStatus: InboxRuleRequestStatus,
    newStatus: InboxRuleRequestStatus
) {
    const errorStr = 'Invalid state transition {0} to {1}';

    if (
        newStatus == InboxRuleRequestStatus.Pending &&
        (oldStatus == InboxRuleRequestStatus.Pending ||
            oldStatus == InboxRuleRequestStatus.Complete)
    ) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }

    if (
        (newStatus == InboxRuleRequestStatus.Complete ||
            newStatus == InboxRuleRequestStatus.Error) &&
        oldStatus != InboxRuleRequestStatus.Pending
    ) {
        trace.error(format(errorStr, oldStatus, newStatus));
    }
}

/**
 * Set the InboxRuleRequestStatus in create rule store
 * @param requestStatus the create rule request status to set
 * @param state the state which contains the create rule store
 */
export default action('setInboxRuleRequestStatus')(
    select({
        inboxRuleStore: () => inboxRuleStore,
    })(function setInboxRuleRequestStatus(
        requestStatus: InboxRuleRequestStatus,
        state?: SetInboxRuleRequestStatusState
    ) {
        const { inboxRuleStore } = state;

        if (!inboxRuleStore.isInboxRuleDialogShown) {
            // Do nothing if the create rule dialog is hidden when try setting InboxRuleRequestStatus, e.g. user dismisses the
            // dialog when the request is outstanding.
            return;
        }

        validateInboxRuleRequestState(inboxRuleStore.inboxRuleRequestStatus, requestStatus);

        inboxRuleStore.inboxRuleRequestStatus = requestStatus;
    })
);
